import type React from 'react';
import SettingStyles from '../../SettingStyle.module.scss';
import { DefaultV2 } from '~/components/common/layouts/DefaultV2';
import { ClientSettingLayout } from '~/components/common/layouts/settings/ClientSettingLayout';
import { CompanyStoreSettingForm } from '~/components/specifics/settings/admin/company_store_settings/CompanyStoreSettingForm';
import type { ItandiAccount } from '~/models/ItandiAccount';

type Props = {
  currentStore: Exclude<ItandiAccount['store'], null>;
};

export const Page: React.FC<Props> = ({ currentStore }) => (
  <DefaultV2>
    <ClientSettingLayout>
      <h2 className={SettingStyles.SettingTitle}>店舗設定</h2>
      <CompanyStoreSettingForm companyStoreSetting={currentStore} />
    </ClientSettingLayout>
  </DefaultV2>
);
